/**
 * Created by - Ashlekh on 03-04-2025
 * Reason - To create Matrimony page
 */
import { useEffect, useState, useContext, useRef } from "react";
import style from "./MatrimonialProfileDetail.module.css";
import parse from "html-react-parser";
import { GlobalContext } from "../../context/Context";
import { useLocation, useParams } from "react-router-dom";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import {
  getMatriMonialDetailsAPI,
  matrimonyRequestDetailsAPI,
} from "../../Api/services";
import config from "../../Api/config";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Box, TextField, Grid, Typography, Button } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import notificationObject from "../../components/Widgets/Notification/Notification";

const MatrimonialProfileDetail = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  const [matrimonialDetails, setMatriMonialDetails] = useState([]);
  const [profile, setProfile] = useState(null);
  const [profileImages, setProfileImages] = useState([]);
  const location = useLocation();
  const id = location.state;
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    email: "",
    occupation: "",
    requested_profile_id: "",
    requested_profile_name: "",
    birth_chart: null,
  });
  const initialValues = {
    name: "",
    mobile_number: "",
    email: "",
    occupation: "",
    requested_profile_id: "",
    requested_profile_name: "",
    birth_chart: null,
  };
  const [errors, setErrors] = useState({});
  const [scanner, setScanner] = useState({});
  // Added by - Ashlekh on 03-04-2025
  // Reason - This useEffect will executes when page loads
  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Matrimonial Details", path: "/matrimonial-profile" },
    ]);
    window.scrollTo(0, 0);
  }, []);
  // End of code - Ashlekh on 03-04-2025
  // Reason - This useEffect will executes when page loads

  useEffect(() => {
    if (id != null && id != "") {
      getMatriMonialDetails();
    }
  }, [id]);

  const getMatriMonialDetails = async () => {
    try {
      const response = await getMatriMonialDetailsAPI();
      setScanner(response?.setting_details);
      setMatriMonialDetails(response?.matrimonial_detail);
      const filteredProfile = response.matrimonial_detail.find(
        (profile) => profile.id === id
      );

      if (filteredProfile) {
        setProfile(filteredProfile);
        const images = [];
        if (filteredProfile.image1) images.push(filteredProfile.image1);
        if (filteredProfile.image2) images.push(filteredProfile.image2);
        if (filteredProfile.image3) images.push(filteredProfile.image3);
        if (filteredProfile.image4) images.push(filteredProfile.image4);
        if (filteredProfile.image5) images.push(filteredProfile.image5);
        setProfileImages(images);
      } else {
        console.error("Profile not found.");
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };

  const responsiveProfileImages = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
      slidesToSlide: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const submitMatrimonyRequest = async (values) => {
    // e.preventDefault();
    // if (!validate()) return;
    try {
      const response = await matrimonyRequestDetailsAPI({
        requested_profile_id: profile.profile_id,
        requested_profile_name: profile.name,
        name: values.name,
        mobile_number: values.mobile_number,
        email: values.email,
        occupation: values.occupation,
        birth_chart: values.birth_chart,
      });
      if (response?.message) {
        notificationObject.success("Submitted Successfully");
        setFormData({
          name: "",
          mobile_number: "",
          email: "",
          occupation: "",
          requested_profile_id: "",
          requested_profile_name: "",
          birth_chart: null,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
        setErrors({});
      }
    } catch (error) {
      console.error("Error during submission:", error);
      notificationObject.error("Something went wrong. Please try again.");
    }
  };
  const validate = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactNumberRegex = /^[1-9]\d{9}$/;
    const occupationRegex =
      /^[A-Za-z0-9\s!@#\$%\^&\*\(\)_\+\-=\[\]{};':"\\|,.<>\/?`~]+$/;

    if (!formData.name) {
      newErrors.name = "Please enter name.";
    } else if (!nameRegex.test(formData.name)) {
      newErrors.name = "Only alphabets are allowed";
    }

    if (!formData.mobile_number) {
      newErrors.mobile_number = "Please Enter mobile number";
    } else if (!contactNumberRegex.test(formData.mobile_number.trim())) {
      newErrors.mobile_number = "Please enter valid mobile number.";
    }

    if (!formData.email) {
      newErrors.email = "Please Enter email ";
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = "Please enter valid email address.";
    }

    if (!formData.occupation.trim()) {
      newErrors.occupation = "Please enter occupation.";
    } else if (!occupationRegex.test(formData.occupation.trim())) {
      newErrors.occupation = "Only alphabets and numbers are allowed.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validationSchema = Yup.object({
    mobile_number: Yup.number()
      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .integer()
      .typeError("Please enter 10 digit mobile number ")
      .required("Please enter mobile number")
      .min(1000000000, "Please enter 10 digit mobile number ")
      .max(9999999999, "Please enter 10 digit mobile number "),

    name: Yup.string()
      .matches(
        /^[a-zA-Z0-9\u0900-\u097F\s]+$/,
        "Please remove special characters"
      )
      .required("Please enter name"),
    email: Yup.string()
      .trim()
      .email("Please enter email in correct format")
      .required("Please enter email"),
    occupation: Yup.string()
      .matches(
        /^[a-zA-Z0-9\u0900-\u097F\s]+$/,
        "Please remove special characters"
      )
      .required("Please enter occupation"),

    birth_chart: Yup.mixed()
      .required("Please select a file")
      .test(
        "fileFormat",
        "Unsupported Format",
        (value) =>
          !value ||
          (value &&
            [
              "application/pdf",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(value.type))
      )
      .test(
        "fileSize",
        "File size is too large, should be less than 5MB",
        (value) => !value || (value && value.size <= 5 * 1024 * 1024)
      ),
  });

  const renderError = (message) => (
    <span className={`${style.validationMsgContainer}`}>{message}</span>
  );

  const onSubmit = (values) => {
    submitMatrimonyRequest(values);
  };
  const fileInputRef = useRef(null);
  const FileInput = ({ field, form, innerRef }) => {
    const handleChange = (event) => {
      form.setFieldValue(field.name, event.currentTarget.files[0]);
    };

    return (
      <input
        type="file"
        onChange={handleChange}
        accept=".pdf,.doc,.docx"
        ref={innerRef}
        className={`${style.fileInput}`}
      />
    );
  };
  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          <NavigationPath navigationPathArray={navigationPath} />

          <div className={`${style.pageTitle}`}>Profile Details</div>
          <div className={`${style.gridContainer}`}>
            <div className={`${style.profileImageContainer}`}>
              <Carousel responsive={responsiveProfileImages} arrows={true}>
                {profileImages?.map((image, index) => {
                  return (
                    <div key={index}>
                      <img
                        className={`${style.profileImage}`}
                        src={config.baseURL + image}
                        alt=""
                      />
                    </div>
                  );
                })}
              </Carousel>
            </div>
            <div className={`${style.profileDetails}`}>
              <div className={`${style.nameContainer}`}>
                <div className={`${style.label}`}>Name</div>
                <span>:</span>
                <div>{profile?.name}</div>
              </div>
              <div className={`${style.genderContainer}`}>
                <div className={`${style.label}`}>Gender</div>
                <span>:</span>
                <div>{profile?.gender}</div>
              </div>
              <div className={`${style.maritalStatus}`}>
                <div className={`${style.label}`}>Marital Status</div>
                <span>:</span>
                <div>{profile?.marital_status}</div>
              </div>
              <div className={`${style.dateOfBirth}`}>
                <div className={`${style.label}`}>Date of birth</div>
                <span>:</span>
                {/* Code changed by - Ashlekh on 05-05-2025
                Reason - To display date format in dd-mm-yyyy */}
                {/* <div>{profile?.date_of_birth}</div> */}
                <div>
                  {profile?.date_of_birth
                    ? new Date(profile.date_of_birth)
                        .toLocaleDateString('en-GB')
                        .replace(/\//g, '-')
                    : ''}
                </div>
                {/* End of code - Ashlekh on 05-05-2025
                Reason - To display date format in dd-mm-yyyy */}
              </div>
            </div>
          </div>
          {/* <div className={`${style.personalInformationContainer}`}>
            <div className={`${style.personalInformationTitle}`}>
              Personal Information
            </div>
            <div className={`${style.personalInformationSubContainer}`}>
              <div className={`${style.personalInformationColumn1}`}>
                <div className={`${style.birthTimeContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Birth Time</div>
                  <span>:</span>
                  <div>{profile?.birth_time}</div>
                </div>
                <div className={`${style.rashiNameContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Rashi</div>
                  <span>:</span>
                  <div>{profile?.rashi}</div>
                </div>
                <div className={`${style.heightContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Height</div>
                  <span>:</span>
                  <div>{profile?.height}</div>
                </div>
                <div className={`${style.weightContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Weight</div>
                  <span>:</span>
                  <div>{profile?.weight}</div>
                </div>
                <div className={`${style.complexionContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Complexion</div>
                  <span>:</span>
                  <div>{profile?.complexion}</div>
                </div>
                <div className={`${style.bloodGroupContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Blood Group</div>
                  <span>:</span>
                  <div>{profile?.blood_group}</div>
                </div>
                <div className={`${style.contactNumberContainer}`}>
                  <div className={`${style.columnOneLabel}`}>
                    Contact Number
                  </div>
                  <span>:</span>
                  <div>{profile?.contact_number}</div>
                </div>
                <div className={`${style.emailContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Email</div>
                  <span>:</span>
                  <div>{profile?.email}</div>
                </div>
                <div className={`${style.occupationContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Profession</div>
                  <span>:</span>
                  <div>{profile?.profession}</div>
                </div>
                <div className={`${style.incomelContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Income</div>
                  <span>:</span>
                  <div>{profile?.income}</div>
                </div>
                <div className={`${style.educationContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Education</div>
                  <span>:</span>
                  <div>{profile?.education}</div>
                </div>
                <div className={`${style.hobbiesContainer}`}>
                  <div className={`${style.columnOneLabel}`}>Hobbies</div>
                  <span>:</span>
                  <div>{profile?.hobbies}</div>
                </div>
                <div className={`${style.partnerExpectationContainer}`}>
                  <div className={`${style.columnOneLabel}`}>
                    Partner Expectation
                  </div>
                  <span>:</span>
                  <div>{profile?.partner_expectation}</div>
                </div>
              </div>
              <div className={`${style.personalInformationColumn2}`}>
                <div className={`${style.fatherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>Father's Name</div>
                  <span>:</span>
                  <div>{profile?.fathers_name}</div>
                </div>
                <div className={`${style.aboutFatherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>About Father</div>
                  <span>:</span>
                  <div>{profile?.fathers_occupation}</div>
                </div>
                <div className={`${style.motherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>Mother's Name</div>
                  <span>:</span>
                  <div>{profile?.mothers_name}</div>
                </div>
                <div className={`${style.aboutMotherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>About Mother</div>
                  <span>:</span>
                  <div>{profile?.mothers_occupation}</div>
                </div>
                <div className={`${style.brotherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>Brother(s)</div>
                  <span>:</span>
                  <div>{profile?.brothers}</div>
                </div>
                <div className={`${style.aboutBrotherContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>
                    About Brother(s)
                  </div>
                  <span>:</span>
                  <div>{profile?.brothers_occupation}</div>
                </div>
                <div className={`${style.sisterContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>Sister(s)</div>
                  <span>:</span>
                  <div>{profile?.sisters}</div>
                </div>
                <div className={`${style.aboutSisterContainer}`}>
                  <div className={`${style.columnTwoLabel}`}>
                    About Sister(s)
                  </div>
                  <span>:</span>
                  <div>{profile?.sisters_occupation}</div>
                </div>
              </div>
            </div>
          </div> */}
          <div className={`${style.formTitle}`}>
            For more details, please complete the payment and fill out the form.
          </div>
          <div className={`${style.gridContainer2}`}>
            <div className={`${style.scannerContainer}`}>
              {scanner?.qr_scanner && (
              <img
                className={`${style.scannerImage}`}
                src={`${config.baseURL + scanner?.qr_scanner}`}
                alt=""
              />
              ) }
            </div>
            <div className={`${style.inputBoxContainer}`}>
              {/* <TextField
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.name}
                helperText={errors.name}
                style={{ marginBottom: "10px" }}
              />
              <TextField
                label="Mobile Number"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.mobile_number}
                helperText={errors.mobile_number}
                style={{ marginBottom: "10px" }}
              />
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.email}
                helperText={errors.email}
                style={{ marginBottom: "10px" }}
              />
              <TextField
                label="Occupation"
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.occupation}
                helperText={errors.occupation}
                style={{ marginBottom: "10px" }}
              />
              <Button
                className={style.submitButton}
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                // fullWidth
              >
                Submit
              </Button> */}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                  await onSubmit(values);
                  resetForm();
                }}
                enableReinitialize={true}
              >
                <Form noValidate={true}>
                  <div className={`${style.inputAndErrorContainer}`}>
                    <div className={`${style.inputHolder}`}>
                      <label className={`${style.label}`}>
                        Name
                        <span style={{ color: "red" }}> * </span>
                      </label>
                      <div className={`${style.colon}`}> : </div>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="name"
                          placeholder="Name"
                          type="text"
                          className={`${style.inputBox}`}
                        />
                      </div>
                    </div>
                    <ErrorMessage name="name" render={renderError} />
                  </div>
                  <div className={`${style.inputAndErrorContainer}`}>
                    <div className={`${style.inputHolder}`}>
                      <label className={`${style.label}`}>
                        Mobile Number
                        <span style={{ color: "red" }}> * </span>
                      </label>
                      <div className={`${style.colon}`}> : </div>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="mobile_number"
                          placeholder="Mobile Number"
                          type="number"
                          className={`${style.inputBox}`}
                        />
                      </div>
                    </div>
                    <ErrorMessage name="mobile_number" render={renderError} />
                  </div>
                  <div className={`${style.inputAndErrorContainer}`}>
                    <div className={`${style.inputHolder}`}>
                      <label className={`${style.label}`}>
                        Email
                        <span style={{ color: "red" }}> * </span>
                      </label>
                      <div className={`${style.colon}`}> : </div>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="email"
                          placeholder="Email"
                          type="text"
                          className={`${style.inputBox}`}
                        />
                      </div>
                    </div>
                    <ErrorMessage name="email" render={renderError} />
                  </div>
                  <div className={`${style.inputAndErrorContainer}`}>
                    <div className={`${style.inputHolder}`}>
                      <label className={`${style.label}`}>
                        Occupation
                        <span style={{ color: "red" }}> * </span>
                      </label>
                      <div className={`${style.colon}`}> : </div>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="occupation"
                          placeholder="Occupation"
                          type="text"
                          className={`${style.inputBox}`}
                        />
                      </div>
                    </div>
                    <ErrorMessage name="occupation" render={renderError} />
                  </div>
                  <div className={`${style.inputAndErrorContainer}`}>
                    <div className={`${style.inputHolder}`}>
                      <label className={`${style.label}`}>
                        {/* Upload Birth Chart */}
                        Upload Birth Chart / Grahanila
                        <span style={{ color: "red" }}> * </span>
                      </label>
                      <div className={`${style.colon}`}> : </div>
                      <div className={`${style.inputWithError}`}>
                        <Field
                          name="birth_chart"
                          component={FileInput}
                          innerRef={fileInputRef}
                          className={`${style.inputBoxUpload}`}
                        />
                      </div>
                    </div>
                    <span className={style.tip}>
                      (Note: Upload the file in Word/Pdf format )
                    </span>
                    <ErrorMessage name="birth_chart" render={renderError} />
                  </div>
                  <div
                    className={`${style.buttonContainer}`}
                    style={{
                      paddingTop: "2%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button className={`${style.button}`} type="submit">
                      Submit
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
    </div>
  );
};
export default MatrimonialProfileDetail;
